import { OpenAPIApiClient } from '@fourthwall/services/dist/OpenAPIApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateOpenAPIConfigurationMutation = createMutationHook(
  OpenAPIApiClient.createConfiguration,
  {
    mutationKey: ['createOpenAPIConfiguration'],
  },
)
